import { FC, Suspense } from 'react';

import { COUNTRY_CODES } from '@savgroup-front-common/constants/shared';

import { Carriers } from '../../api/Claim/getClaimGroupTransportPlanQuery';
import { BaseLoader } from '../BaseLoader';

import { AppointmentCardContent } from './AppointmentCardContent';

interface AppointmentCardProps {
  fileId: string;
  productLocationCountryCode: COUNTRY_CODES;
  carrier: Carriers;
  carrierForTMS?: string;
  onSubmit?: () => void;
  onCancel?: () => void;
  onPreviousStepClick?: () => void;
}

const AppointmentCard: FC<AppointmentCardProps> = ({
  fileId,
  productLocationCountryCode,
  carrier,
  carrierForTMS,
  onSubmit,
  onPreviousStepClick,
  onCancel,
}) => {
  return (
    <Suspense fallback={<BaseLoader />}>
      <AppointmentCardContent
        carrier={carrier}
        carrierForTMS={carrierForTMS}
        fileId={fileId}
        countryCode={productLocationCountryCode}
        onSubmit={onSubmit}
        onPreviousStepClick={onPreviousStepClick}
        onCancel={onCancel}
      />
    </Suspense>
  );
};

export default AppointmentCard;
